// extracted by mini-css-extract-plugin
module.exports = {"button":"src-components-Tickets-AddWechatAccountModal-AddWechatAccountModal-module__button--mUTcv"};